const React = require('react');
const Layout = require('./src/components/Layout').default;
const StoreProvider = require('./src/store').default;

/**
 * wrapp app with provider for dispatch cart and customer infos
 */
exports.wrapRootElement = ({element}) => {
  return <StoreProvider>{element}</StoreProvider>;
};

exports.wrapPageElement = ({element, props}) => {
  return <Layout {...props}>{element}</Layout>;
};
